import React from 'react';
import { useGlobalState } from '../../stateProvider/StateProvider';
import FormSetting from '../../layout/FormSetting';
import Checkbox from '../../forms/Checkbox';
import { QuestRoute } from '../../api/QuestRoutes';
import HamQuest from '../../api/HamQuestGiver';

const Locations = ({ ...props }) => {
    const {
        state: {
            locations
        },
    } = useGlobalState();

    return (
        <FormSetting
            label='Show in App Locations'
            getInputs={QuestRoute.settings.appLocations}
            onSubmit={e => HamQuest.put(QuestRoute.settings.appLocations, { ...e })}
            editable
        >
            {
                locations.map((e, i) => (
                    <Checkbox
                        key={'locations' + i}

                        name='locations'
                        label={e.label}
                        value={e.value}
                    />
                ))
            }
        </FormSetting>
    );
}

export default Locations;